import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MovimientosInventarioService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/movimientos-inventario', httpClient, authService);
  }

  getMovimientos(params?: any): Observable<any> {
    return this.get('', params);
  }

  getHistorialProducto(productoId: number): Observable<any> {
    return this.get(`producto/${productoId}`);
  }
}
